import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'milestones/v4/templates';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('milestones/', '')
      .toLowerCase();
  }
}
